<!--Barra de navegación de usuario de Organizador WeChamber-->
<template>
  <div>
    <!-- MENÚ LATERAL DEL ADMINISTRADOR -->
    <v-navigation-drawer
      v-model="drawer"
      app
      color="rgb(29,43,59)"
      dark
      floating
      mobile-break-point="1100"
      fixed
      :width="($vuetify.breakpoint.xlOnly)?'256px': '210px'"
      style="background: linear-gradient(180deg, rgba(29,43,59,1) 0%, rgba(31,72,126,1) 100%);"
    >
      <v-list-item style="height:80px">
        <v-row justify="center" class="mt-10">
          <v-avatar size="80">
            <v-img :src="user.profilePicture" contain />
          </v-avatar>
        </v-row>
      </v-list-item>
      <v-list-item class="mt-5">
        <v-row justify="center">
          <v-col cols="12" class="text-center headline font-weight-bold">{{ user.companyName }}</v-col>
        </v-row>
      </v-list-item>

      <v-divider class="mx-3 mb-3" />

      <v-list nav>
        <!--<v-list-item v-if="user.validationStatus && user.validationStatus == 'IN_PROCESS'">
          <v-menu end offset-y max-width="500px">
            <template v-slot:activator="{ on }">
              <v-btn color="accent" v-on="on" block><strong>Incompleto</strong></v-btn>
            </template>
            <div class="px-4 pt-2 pb-4 mx-2 mx-sm-0" style="background-color: white;">
              <p class="title font-weight-bold">Tu cuenta ya se encuentra activa y lista para recibir pagos. Para completar tu documentación solicitamos nos hagas llegar los siguientes documentos al correo soporte@wechamber.mx</p>
              
              <v-row>
                <v-col cols="1" class="py-0">
                  <v-icon left color="primary">mdi-file-document</v-icon>
                </v-col>
                <v-col cols="11" sm="10" class="py-0">
                  <p class="my-1">Acta Constitutiva.</p>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="1" class="py-0">
                  <v-icon left color="primary">mdi-file-document</v-icon>
                </v-col>
                <v-col cols="11" sm="10" class="py-0">
                  <p class="my-1">Constancia de Situación Fiscal.</p>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="1" class="py-0">
                  <v-icon left color="primary">mdi-file-document</v-icon>
                </v-col>
                <v-col cols="11" sm="10" class="py-0">
                  <p class="my-1">Comprobante de domicilio.</p>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="1" class="py-0">
                  <v-icon left color="primary">mdi-file-document</v-icon>
                </v-col>
                <v-col cols="11" sm="10" class="py-0">
                  <p class="my-1">Copia de Identificación Oficial del Representante Legal.</p>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="1" class="py-0">
                  <v-icon left color="primary">mdi-file-document</v-icon>
                </v-col>
                <v-col cols="11" sm="10" class="py-0">
                  <p class="my-1">Carátula de Estado de cuenta del Banco (que se pueda apreciar la CLABE).</p>
                </v-col>
              </v-row>
              <p class="subtitle-1 font-weight-bold pt-4">Una vez recibidos y validados, recibirás a tu correo el contrato con tus datos cargados, mismo que deberás imprimir, firmar y escanear de regreso al correo soporte@wechamber.mx.</p>
            </div>
          </v-menu>
        </v-list-item>-->
        <v-list-item v-if="user.validationStatus && user.validationStatus == 'IN_PROCESS'">
          <v-dialog v-model="incompleteDialog" max-width="700">
            <template v-slot:activator="{ on }">
              <v-btn color="accent" v-on="on" block><strong>Incompleto</strong></v-btn>
            </template>
            <v-card >
              <v-card-text>
                <v-container class="px-1">
                  <v-row class="justify-space-between">
                    <v-col cols="12" class="pb-0 ma-0">
                      <v-img src="@/assets/loader-logo-completo.png" width="160px" max-height="auto" style="margin: auto;"></v-img>
                    </v-col>
                  </v-row>
                  <v-row class="mt-5" v-if="$vuetify.breakpoint.xsOnly">
                    <v-btn color="amber" @click="incompleteDialog=false" block>Cerrar</v-btn>
                  </v-row>
                  <v-row>
                    <v-col cols="12" class="pb-0 ma-0 px-2">
                      <p class="title text-sm-justify font-weight-bold mb-1">Tu cuenta ya se encuentra activa y lista para recibir pagos. Para completar tu cuenta solicitamos nos hagas llegar los siguientes documentos al correo <strong class="secondary--text">soporte@wechamber.mx</strong></p>
                    </v-col>
                  </v-row>
                  <v-row class="px-0">
                    <v-col cols="12" class="black--text pb-0">
                      <v-row>
                          <v-col cols="1" class="py-0">
                            <v-icon left color="primary">mdi-file-document</v-icon>
                          </v-col>
                          <v-col cols="10" sm="10" class="py-0">
                            <p class="my-1">Acta Constitutiva.</p>
                          </v-col>
                        </v-row>
                        <v-row>
                          <v-col cols="1" class="py-0">
                            <v-icon left color="primary">mdi-file-document</v-icon>
                          </v-col>
                          <v-col cols="10" sm="10" class="py-0">
                            <p class="my-1">Constancia de Situación Fiscal.</p>
                          </v-col>
                        </v-row>
                        <v-row>
                          <v-col cols="1" class="py-0">
                            <v-icon left color="primary">mdi-file-document</v-icon>
                          </v-col>
                          <v-col cols="10" sm="10" class="py-0">
                            <p class="my-1">Comprobante de domicilio.</p>
                          </v-col>
                        </v-row>
                        <v-row>
                          <v-col cols="1" class="py-0">
                            <v-icon left color="primary">mdi-file-document</v-icon>
                          </v-col>
                          <v-col cols="10" sm="10" class="py-0">
                            <p class="my-1">Copia de Identificación Oficial del Representante Legal.</p>
                          </v-col>
                        </v-row>
                        <v-row>
                          <v-col cols="1" class="py-0">
                            <v-icon left color="primary">mdi-file-document</v-icon>
                          </v-col>
                          <v-col cols="10" sm="10" class="py-0">
                            <p class="my-1">Carátula de Estado de cuenta del Banco (que se pueda apreciar la CLABE).</p>
                          </v-col>
                        </v-row>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12" class="pb-0 ma-0 px-2">
                      <p class="title text-justify font-weight-bold mb-1">Una vez recibidos y validados, recibirás a tu correo el contrato con tus datos cargados, mismo que deberás imprimir, firmar y escanear de regreso al correo <strong class="secondary--text">soporte@wechamber.mx</strong></p>
                    </v-col>
                  </v-row>
                  <v-row class="mt-5" v-if="$vuetify.breakpoint.smAndUp">
                    <v-btn color="amber" @click="incompleteDialog=false">Cerrar</v-btn>
                  </v-row>
                </v-container>
              </v-card-text>
            </v-card>
          </v-dialog>
        </v-list-item>
        <v-list-item v-if="user.validationStatus && user.validationStatus == 'VALIDATED'">
          <v-dialog v-model="incompleteDialog" max-width="700">
            <template v-slot:activator="{ on }">
              <v-btn color="success" v-on="on" block><strong>Completado</strong></v-btn>
            </template>
            <v-card >
              <v-card-text>
                <v-container class="px-1">
                  <v-row class="justify-space-between">
                    <v-col cols="12" class="pb-0 ma-0">
                      <v-img src="@/assets/logo-WC-solo.png" width="50px" max-height="auto" style="margin: auto;"></v-img>
                    </v-col>
                  </v-row>
                  <v-row class="mt-8">
                    <v-col cols="12" class="pb-0 ma-0 px-2">
                      <p class="display-2 text-center font-weight-bold mb-1 secondary--text">¡Gracias!</p>
                      <p class="title text-center font-weight-bold mb-1"> Tu documentación ha sido completada exitosamente.</p>
                    </v-col>
                  </v-row>
                  <v-row class="mt-12" justify="center">
                    <v-btn color="amber" @click="incompleteDialog=false">Cerrar</v-btn>
                  </v-row>
                </v-container>
              </v-card-text>
            </v-card>
          </v-dialog>
        </v-list-item>
        <v-list-item
          v-for="(item, i) in menuItems"
          :key="i"
          :to="item.link"
          active-class="primary white--text"
          :disabled="item.disabled"
        >
          <v-list-item-action>
            <v-icon>{{ item.icon }}</v-icon>
          </v-list-item-action>

          <v-list-item-title>
            <span class="subtitle-1">{{item.title}}</span>
          </v-list-item-title>
        </v-list-item>
        <v-list-item
          to="/dashboard/checkin"
          active-class="primary white--text"
          class="d-flex d-lg-none"
        >
          <!-- <v-list-item to="/dashboard/checkin" active-class="primary white--text"> -->
          <v-list-item-action>
            <v-icon>fas fa-qrcode</v-icon>
          </v-list-item-action>
          <v-list-item-title>
            <span class="subtitle-1">CheckIn</span>
          </v-list-item-title>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>

    <!-- MENÚ SUPERIOR DEL ADMINISTRADOR -->
    <v-app-bar id="core-app-bar" color="transparent" flat height="75" v-if="true">
      <v-toolbar-title class="tertiary--text font-weight-light align-self-center">
        <v-app-bar-nav-icon v-if="responsive" icon @click.stop="drawer = !drawer"></v-app-bar-nav-icon>
      </v-toolbar-title>
      <v-breadcrumbs
        class="d-none d-sm-flex"
        :items="breadcrumbList"
        :class="($vuetify.breakpoint.xlOnly)?'bigMargin': ($vuetify.breakpoint.lgOnly)?'smallMargin':''"
      ></v-breadcrumbs>
      <v-spacer></v-spacer>
      <v-toolbar-items>
        <v-btn text @click="userLogout()">
          <v-icon class="mx-2">fas fa-sign-out-alt</v-icon>Cerrar sesión
        </v-btn>
      </v-toolbar-items>
    </v-app-bar>
  </div>
</template>

<script>
import { mapMutations, mapState } from "vuex";
export default {
  data: () => ({
    breadcrumbList: [],
    incompleteDialog: false,
    company: {
      name: "WeChamber",
      logo:
        "https://v2.wechamber.mx/api/files/usuario1/download/z15MFQ0r_400x400.jpg"
    },
    drawer: null,
    responsive: false,
    menuItems: [
      {
        icon: "fas fa-chart-area",
        title: "Mi tablero",
        link: "/dashboard/inicio"
      },
      {
        icon: "fas fa-map-marker-alt",
        title: "Mis eventos",
        link: "/dashboard/eventos"
      },
      {
        icon: "fas fa-plus",
        title: "Nuevo evento",
        link: "/dashboard/nuevo-evento",
        //disabled: true
      },
      /*
      {
        icon: "fas fa-medal",
        title: "Mis afiliaciones",
        link: "/dashboard/afiliaciones"
      },*/
      /*
      {
        icon: "fas fa-plus",
        title: "Nueva afiliación",
        link: "/dashboard/nueva-afiliacion"
      },*/
      {
        icon: "fas fa-user-circle",
        title: "Mi perfil",
        link: "/dashboard/perfil"
      }
    ]
  }),
  mounted() {
    this.onResponsiveInverted();
    window.addEventListener("resize", this.onResponsiveInverted);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.onResponsiveInverted);
  },
  computed: {
    ...mapState("user", ["user"])
  },
  methods: {
    onResponsiveInverted() {
      if (window.innerWidth < 1100) {
        this.responsive = true;
      } else {
        this.responsive = false;
      }
    },
    ...mapMutations("user", ["logout"]),
    userLogout() {
      this.logout();
      this.$router.push("/login");
    }
  },
  watch: {
    $route() {
      if (this.$route.meta.breadcrumbs)
        this.breadcrumbList = this.$route.meta.breadcrumbs;
      else this.breadcrumbList = [];
    }
  }
};
</script>

<style scoped>
#core-app-bar {
  width: auto;
}

#core-app-bar a {
  text-decoration: none;
}

.bigMargin {
  margin-left: 256px;
}
.smallMargin {
  margin-left: 210px;
}
.disabled {
  color: #1d2b3b;
  pointer-events: none;
}
</style>
